import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CapacityTypeSelectorOverlay',
  props: {
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    colors: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentlySelected: {
      type: Object,
      default: function _default() {}
    },
    onPlp: {
      type: Boolean,
      default: false
    }
  },
  emits: ['selectCapacity', 'sameItemSelected', 'close'],
  setup: function setup(__props, _ref) {
    var _props$colors;
    var emit = _ref.emit;
    var props = __props;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var activeItem = ref(props.currentlySelected);
    var hasMoreThanOneColor = ref((props === null || props === void 0 ? void 0 : (_props$colors = props.colors) === null || _props$colors === void 0 ? void 0 : _props$colors.length) > 1);
    var selectedItem = ref(null);
    var currentPrice = ref({
      regular: '',
      special: ''
    });
    var optionsFiltered = computed(function () {
      return props.options.filter(function (item) {
        return !item.isDiscontinued;
      });
    });
    var isItemSelected = function isItemSelected(item) {
      return item.capacity === activeItem.value.capacity && item['capacity-unit'] === activeItem.value['capacity-unit'] && item['capacity-type'] === activeItem.value['capacity-type'];
    };
    var activeIndex = ref(props.options.findIndex(function (item) {
      return isItemSelected(item);
    }));
    var onSelected = function onSelected(item, index) {
      selectedItem.value = item;
      activeIndex.value = index;
      currentPrice.value = getPriceForDiscount(item.price);
      if (props.onPlp && !hasMoreThanOneColor.value) return;
      emitSelectedItem(item);
    };
    var emitSelectedItem = function emitSelectedItem(item) {
      if (item.capacity !== activeItem.value.capacity || item['capacity-unit'] !== activeItem.value['capacity-unit'] || item['capacity-type'] !== activeItem.value['capacity-type']) {
        emit('selectCapacity', item);
      } else {
        emit('sameItemSelected', item);
      }
    };
    var close = function close() {
      onSelected(props.currentlySelected);
      emit('close');
    };
    var getPriceForDiscount = function getPriceForDiscount(item) {
      var _item$value, _item$discounted, _item$discounted$valu;
      return {
        regular: item === null || item === void 0 ? void 0 : (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.centAmount,
        special: item === null || item === void 0 ? void 0 : (_item$discounted = item.discounted) === null || _item$discounted === void 0 ? void 0 : (_item$discounted$valu = _item$discounted.value) === null || _item$discounted$valu === void 0 ? void 0 : _item$discounted$valu.centAmount
      };
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      translate: translate,
      activeItem: activeItem,
      hasMoreThanOneColor: hasMoreThanOneColor,
      selectedItem: selectedItem,
      currentPrice: currentPrice,
      optionsFiltered: optionsFiltered,
      isItemSelected: isItemSelected,
      activeIndex: activeIndex,
      onSelected: onSelected,
      emitSelectedItem: emitSelectedItem,
      close: close,
      getPriceForDiscount: getPriceForDiscount,
      AzIcon: AzIcon,
      PriceDisplay: PriceDisplay
    };
  }
});